import React, { useEffect, useRef } from "react";

/* GhostLayer — cursor spotlight + film grain + scanlines, site-wide cinematic depth */
const GhostLayer = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const el = ref.current;
    let raf, tx = 0, ty = 0, cx = 0, cy = 0;
    const onMove = (e) => { tx = e.clientX; ty = e.clientY; };
    window.addEventListener("mousemove", onMove, { passive: true });
    const loop = () => {
      raf = requestAnimationFrame(loop);
      cx += (tx - cx) * 0.12;
      cy += (ty - cy) * 0.12;
      el.style.background = `radial-gradient(600px circle at ${cx}px ${cy}px, rgba(168,85,247,0.07), rgba(229,197,111,0.03) 40%, transparent 65%)`;
    };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); window.removeEventListener("mousemove", onMove); };
  }, []);

  return (
    <>
      <div ref={ref} className="fixed inset-0 z-[60] pointer-events-none" data-testid="ghost-spotlight" />
      <div className="fixed inset-0 z-[59] pointer-events-none opacity-[0.05] ghost-scanlines" aria-hidden="true" />
      <div className="fixed -inset-[3%] z-[58] pointer-events-none opacity-[0.05] ghost-grain" aria-hidden="true" data-testid="ghost-grain" />
    </>
  );
};

export default GhostLayer;
